import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import {
	QueryClientProvider,
	QueryClient,
	QueryCache,
	MutationCache,
} from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import toast, { Toaster } from 'react-hot-toast';

import { en } from './i18next/admin/locales';

import { I18nextProvider, initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18next from 'i18next';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme/chakra';

import { BsFillCheckCircleFill, BsFillXCircleFill } from 'react-icons/bs';

// import { useQueryErrorResetBoundary } from 'react-query'
//

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		// lng: localStorage.getItem('langPreference') ?? 'en', // if you're using a language detector, do not define the lng option
		fallbackLng: 'en',
		debug: true,
		resources: {
			en: { translation: en },
			// de: { translation: de },
		},
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
	});

const fiveMinutesInMs = 0;
const queryClient = new QueryClient({
	mutationCache: new MutationCache({
		onError: (error: any) => {
			toast.error(error.message);

			// toast.error(error)
		},
	}),

	defaultOptions: {
		mutations: {
			onError: (error) => console.log(error, 'From mutation error'),
		},

		queries: {
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			refetchOnReconnect: false,
			retry: false,
			cacheTime: fiveMinutesInMs,
			staleTime: fiveMinutesInMs,
		},
	},
});
ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<I18nextProvider i18n={i18next}>
				<QueryClientProvider client={queryClient}>
					<ChakraProvider theme={theme}>
						<App />

						{/* <ToastComponent /> */}

						<Toaster
							containerStyle={{ zIndex: 9999999999, borderRadius: '0px' }}
							gutter={10}
							toastOptions={{
								style: {
									padding: '15px 30px',
									borderRadius: '4px',
									maxWidth: '435px',
									fontSize: '16px',
								},
								error: {
									duration: 2000,
									icon: <BsFillXCircleFill color='#FF3350' size={'32px'} />,
								},
								success: {
									duration: 1500,
									icon: <BsFillCheckCircleFill color='#1ED760' size={'32px'} />,
								},
							}}
						/>
					</ChakraProvider>
					<ReactQueryDevtools initialIsOpen={false} />
				</QueryClientProvider>
			</I18nextProvider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
